import "./shared/styles/index.scss";
import AppRouter from "./config/routes";
import { useEffect, useState } from "react";
import { Modal } from "./ui/modal/modal";
import { Button, ButtonColors, ButtonSizes } from "./ui/button/button";
import { ReactComponent as CrossIcon } from "./shared/images/svg/cross.svg";
import { OfflinePage } from "./pages/offline-page/offline-page";

function App() {
  const [isShowModal, setIsshowModal] = useState(false);
  const [isOnline, setIsOnline] = useState(true);

  window.addEventListener("beforeinstallprompt", async (event: any) => {
    if (event) {
      event.preventDefault();
      let btn = document.getElementById("dwnldBtn");
      if (btn) {
        btn.addEventListener("click", async () => {
          const result = await event.prompt();
          setIsshowModal(false);
        });
      }
      setIsshowModal(true);
    }
  });

  window.addEventListener("online", () => {
    setIsOnline(true);
  });

  window.addEventListener("offline", () => {
    setIsOnline(false);
  });

  if (isOnline) {
    return (
      <>
        <Modal id="saveAppMobile" isShowDialog={isShowModal} setIsShowDialog={setIsshowModal}>
          <div className="download_modal">
            <Button
              onClick={() => setIsshowModal(false)}
              icon={<CrossIcon />}
              color={ButtonColors.transition}
              size={ButtonSizes.small}
            />
            <p>Вы можете установить приложение на свое устройство!</p>
            <Button
              id="dwnldBtn"
              text="Установить"
              size={ButtonSizes.big}
              color={ButtonColors.green}
            />
          </div>
        </Modal>
        <AppRouter />
      </>
    );
  } else {
    return <OfflinePage />;
  }
}

export default App;
